var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHidePasswordIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Hide_Password_Icon",
    "data-name": "Hide Password Icon",
    transform: "translate(-0.343 -0.343)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "invisible_box",
    "data-name": "invisible box"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14",
    "data-name": "Rectangle 14",
    width: 24,
    height: 24,
    transform: "translate(0.343 0.343)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icons_Q2",
    "data-name": "icons Q2",
    transform: "translate(1.025 3.296)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_36",
    "data-name": "Group 36"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M32.929,16.629C31.864,15.311,27.908,11,22.127,11a11.867,11.867,0,0,0-1.927.152l1.826,1.876h.1c4.463,0,7.759,3.144,8.976,4.564a17.091,17.091,0,0,1-2.333,2.181l1.42,1.42a15.265,15.265,0,0,0,2.739-2.637,1.521,1.521,0,0,0,0-1.927Z",
    transform: "translate(-10.981 -8.718)",
    fill: "#2666cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M15.906,16.693a2.941,2.941,0,0,0,.3-1.319,3.043,3.043,0,0,0-3.043-3.043,2.941,2.941,0,0,0-1.319.3L5.916,6.7A1.014,1.014,0,0,0,4.5,8.123l2.384,2.434a16.279,16.279,0,0,0-4.514,3.854,1.521,1.521,0,0,0,0,1.927c1.065,1.319,5.021,5.629,10.8,5.629a11.664,11.664,0,0,0,4.311-.811l2.941,2.891a1.014,1.014,0,1,0,1.42-1.42Zm-2.739,3.246c-4.463,0-7.759-3.144-8.976-4.564A15.062,15.062,0,0,1,8.4,12.028l2.029,2.029a2.941,2.941,0,0,0-.3,1.319,3.043,3.043,0,0,0,3.043,3.043,2.941,2.941,0,0,0,1.319-.3l1.42,1.42a9.686,9.686,0,0,1-2.739.406Z",
    transform: "translate(-2.022 -6.5)",
    fill: "#2666cf"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHidePasswordIcon);
export default __webpack_public_path__ + "static/media/hide-password-icon.531e36170cbace06bc8e17c0dfa9b3a6.svg";
export { ForwardRef as ReactComponent };